import type { CountryIso } from "~/types";

const moroccoEligibleCountries: CountryIso[] = [
  "AZE",
  "GTM",
  "IND",
  "ISR",
  "JOR",
  "THA",
  "BEN"
];

export default moroccoEligibleCountries;